import { Store } from "redux";
import { pickOnBoardingNotification } from "../../../Home/actions/onBoardingUI";

export function errorOBNotification(message: string, title?: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;

  if (store) {
    store.dispatch(
      pickOnBoardingNotification({
        title,
        message: message,
        type: "error"
      })
    );
  }
}

export function successOBNotification(message: string, title?: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;

  if (store) {
    store.dispatch(
      pickOnBoardingNotification({
        title,
        message: message,
        type: "success"
      })
    );
  }
}

export function infoOBNotification(message: string, title?: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;

  if (store) {
    store.dispatch(
      pickOnBoardingNotification({
        title,
        message: message,
        type: "info"
      })
    );
  }
}

export function warningOBNotification(message: string, title?: string): void {
  const store = window["_GLOBAL_REDUX_STORE"] as Store<any>;

  if (store) {
    store.dispatch(
      pickOnBoardingNotification({
        title,
        message: message,
        type: "warning"
      })
    );
  }
}
